import { nanoid } from "nanoid";

/**
 * Generate a unique ID using nanoid.
 * Optionally prefixed with a type label (trimmed, lowercased, spaces → underscores).
 *
 * This is extracted into its own module so it can be imported from both
 * client-side code and server-side API routes without pulling in React dependencies.
 */
export const getId = (type?: string) => {
  const id = nanoid().replaceAll("-", "_").toLowerCase();
  if (!type) return id;
  const prefix = type.trim().toLowerCase().replaceAll(" ", "_");
  return `${prefix}_${id}`;
};
